import { render, staticRenderFns } from "./ViewExpense.vue?vue&type=template&id=ba955b18&scoped=true"
import script from "./ViewExpense.vue?vue&type=script&lang=js"
export * from "./ViewExpense.vue?vue&type=script&lang=js"
import style0 from "./ViewExpense.vue?vue&type=style&index=0&id=ba955b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba955b18",
  null
  
)

export default component.exports